var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 23C6.81455 23 4.22182 23 2.61092 21.389C1 19.7782 1 17.1854 1 12C1 6.81455 1 4.22182 2.61092 2.61092C4.22182 1 6.81455 1 12 1C17.1854 1 19.7782 1 21.389 2.61092C23 4.22182 23 6.81455 23 12C23 17.1854 23 19.7782 21.389 21.389C19.7782 23 17.1854 23 12 23ZM8.66662 8.66664C8.98879 8.34446 9.51116 8.34446 9.83333 8.66664L12 10.8333L14.1666 8.66666C14.4887 8.34448 15.0111 8.34448 15.3333 8.66666C15.6555 8.98884 15.6555 9.51121 15.3333 9.83333L13.1667 12L15.3333 14.1667C15.6555 14.4888 15.6555 15.0111 15.3333 15.3333C15.0111 15.6555 14.4887 15.6555 14.1666 15.3333L12 13.1668L9.83333 15.3333C9.51118 15.6555 8.98882 15.6555 8.66664 15.3333C8.34446 15.0111 8.34446 14.4889 8.66664 14.1667L10.8332 12L8.66662 9.83333C8.34444 9.51118 8.34444 8.98882 8.66662 8.66664Z",
    fill: "#5B57D1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseNew);
export default __webpack_public_path__ + "static/media/close_new.9b738c81282e84d129d3ef97c7fb6816.svg";
export { ForwardRef as ReactComponent };